var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "set-password-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit()
        },
      },
    },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMessage,
                expression: "showMessage",
              },
            ],
            class: _vm.classObject,
          },
          [_vm._v(_vm._s(_vm.error || _vm.success || _vm.tokenError))]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.tokenError,
              expression: "!tokenError",
            },
          ],
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.token,
                  expression: "!token",
                },
              ],
              staticClass: "input-section w-100",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.passwordCurrent,
                    expression: "passwordCurrent",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "password",
                  name: "passwordCurrent",
                  placeholder: "Current Password",
                  disabled: _vm.isDisabled,
                },
                domProps: { value: _vm.passwordCurrent },
                on: {
                  change: _vm.textChanged,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.passwordCurrent = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-section w-100 mt-2 position-relative" },
            [
              (_vm.showPassword ? "text" : "password") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "form-control pe-5",
                    attrs: {
                      name: "password",
                      placeholder: "New Password",
                      disabled: _vm.isDisabled,
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.password)
                        ? _vm._i(_vm.password, null) > -1
                        : _vm.password,
                    },
                    on: {
                      input: _vm.validatePasswordField,
                      change: function ($event) {
                        var $$a = _vm.password,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.password = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.password = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.password = $$c
                        }
                      },
                    },
                  })
                : (_vm.showPassword ? "text" : "password") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "form-control pe-5",
                    attrs: {
                      name: "password",
                      placeholder: "New Password",
                      disabled: _vm.isDisabled,
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.password, null) },
                    on: {
                      input: _vm.validatePasswordField,
                      change: function ($event) {
                        _vm.password = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "form-control pe-5",
                    attrs: {
                      name: "password",
                      placeholder: "New Password",
                      disabled: _vm.isDisabled,
                      type: _vm.showPassword ? "text" : "password",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.password = $event.target.value
                        },
                        _vm.validatePasswordField,
                      ],
                    },
                  }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa-solid",
                class: _vm.showPassword ? "fa-eye-slash" : "fa-eye",
                staticStyle: {
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#999",
                },
                on: { click: _vm.togglePasswordVisibility },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-section w-100 mt-2 position-relative" },
            [
              (_vm.showPasswordConfirm ? "text" : "password") === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordConfirm,
                        expression: "passwordConfirm",
                      },
                    ],
                    staticClass: "form-control pe-5",
                    attrs: {
                      name: "passwordConfirm",
                      placeholder: "Confirm Password",
                      disabled: _vm.isDisabled,
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.passwordConfirm)
                        ? _vm._i(_vm.passwordConfirm, null) > -1
                        : _vm.passwordConfirm,
                    },
                    on: {
                      input: _vm.validateConfirmPassword,
                      change: function ($event) {
                        var $$a = _vm.passwordConfirm,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.passwordConfirm = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.passwordConfirm = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.passwordConfirm = $$c
                        }
                      },
                    },
                  })
                : (_vm.showPasswordConfirm ? "text" : "password") === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordConfirm,
                        expression: "passwordConfirm",
                      },
                    ],
                    staticClass: "form-control pe-5",
                    attrs: {
                      name: "passwordConfirm",
                      placeholder: "Confirm Password",
                      disabled: _vm.isDisabled,
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.passwordConfirm, null) },
                    on: {
                      input: _vm.validateConfirmPassword,
                      change: function ($event) {
                        _vm.passwordConfirm = null
                      },
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordConfirm,
                        expression: "passwordConfirm",
                      },
                    ],
                    staticClass: "form-control pe-5",
                    attrs: {
                      name: "passwordConfirm",
                      placeholder: "Confirm Password",
                      disabled: _vm.isDisabled,
                      type: _vm.showPasswordConfirm ? "text" : "password",
                    },
                    domProps: { value: _vm.passwordConfirm },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.passwordConfirm = $event.target.value
                        },
                        _vm.validateConfirmPassword,
                      ],
                    },
                  }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fa-solid",
                class: _vm.showPasswordConfirm ? "fa-eye-slash" : "fa-eye",
                staticStyle: {
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#999",
                },
                on: { click: _vm.toggleConfirmPasswordVisibility },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions d-flex justify-content-end mt-2" },
            [
              _c(
                "button",
                {
                  staticClass: "submit btn btn-primary",
                  attrs: { type: "submit", disabled: _vm.isDisabled },
                },
                [_vm._v("Submit")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tokenError,
              expression: "tokenError",
            },
          ],
          staticClass: "actions",
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-default float-end",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v("Close")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }